<template>
  <adminTable
    :hideResetButton="true"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:table>
      <el-table-column prop="date" label="时间" />
      <el-table-column prop="capital" label="本金" />
      <el-table-column prop="earn" label="利息" />
      <el-table-column label="操作" width="150" >
          <template #default="scope">
              <el-button type="primary" icon="Search" @click="toPath(scope.row)">查看</el-button>
          </template>
      </el-table-column>
    </template>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
const searchForm = ref({
});

onMounted(() => {
  getList();
});

const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);
const toPath = (item) => {
  proxy.$router.push({
    path: "/buyRecordList",
    query: {
      date: item.date,
      cycle: item.cycle,
    },
  });
}
const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/index/monthEarn",
    params: {},
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data;
  }
};
</script>

<style lang="less" scoped></style>
